export default "__VITE_ASSET__D8vlIJ$g__"